import {analyticsClient} from '../../../../analytics-client';

export function trackModalPageLoad(modalUrl: string) {
    const pageUrl = location.pathname;
    analyticsClient.track(analyticsClient.EVENTS.TRACK_EMAIL_CONFIG_MODAL_PAGE_VIEWED, {
        modalUrl,
        pageUrl,
    });
}
